import { render } from "./WeekMetrics.vue?vue&type=template&id=2b34d040&scoped=true"
import script from "./WeekMetrics.vue?vue&type=script&lang=js"
export * from "./WeekMetrics.vue?vue&type=script&lang=js"

import "./WeekMetrics.vue?vue&type=style&index=0&id=2b34d040&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b34d040"]])

export default __exports__